import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { getBlobFromURL } from './getBlobFromURL';
import { getMimeType, isDataUrl, makeDataUrl, resolveUrl } from './util';
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
export function toRegex(url) {
  // eslint-disable-next-line no-useless-escape
  var escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
  return new RegExp("(url\\(['\"]?)(".concat(escaped, ")(['\"]?\\))"), 'g');
}
export function parseURLs(cssText) {
  var result = [];
  cssText.replace(URL_REGEX, function (raw, quotation, url) {
    result.push(url);
    return raw;
  });
  return result.filter(function (url) {
    return !isDataUrl(url);
  });
}
export function embed(cssText, resourceURL, baseURL, options, get) {
  var resolvedURL = baseURL ? resolveUrl(resourceURL, baseURL) : resourceURL;
  return Promise.resolve(resolvedURL).then(function (url) {
    return get ? get(url) : getBlobFromURL(url, options);
  }).then(function (data) {
    if (typeof data === 'string') {
      return makeDataUrl(data, getMimeType(resourceURL));
    }

    return makeDataUrl(data.blob, getMimeType(resourceURL) || data.contentType);
  }).then(function (dataURL) {
    return cssText.replace(toRegex(resourceURL), "$1".concat(dataURL, "$3"));
  }).then(function (content) {
    return content;
  }, function () {
    return resolvedURL;
  });
}

function filterPreferredFontFormat(str, _ref) {
  var preferredFontFormat = _ref.preferredFontFormat;
  return !preferredFontFormat ? str : str.replace(FONT_SRC_REGEX, function (match) {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      var _ref2 = URL_WITH_FORMAT_REGEX.exec(match) || [],
          _ref3 = _slicedToArray(_ref2, 3),
          src = _ref3[0],
          format = _ref3[2];

      if (!format) {
        return '';
      }

      if (format === preferredFontFormat) {
        return "src: ".concat(src, ";");
      }
    }
  });
}

export function shouldEmbed(url) {
  return url.search(URL_REGEX) !== -1;
}
export function embedResources(cssText, baseUrl, options) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var filteredCSSText;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (shouldEmbed(cssText)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(cssText));

          case 2:
            filteredCSSText = filterPreferredFontFormat(cssText, options);
            return _context.abrupt("return", Promise.resolve(filteredCSSText).then(parseURLs).then(function (urls) {
              return urls.reduce(function (deferred, url) {
                return (// eslint-disable-next-line promise/no-nesting
                  deferred.then(function (css) {
                    return embed(css, url, baseUrl, options);
                  })
                );
              }, Promise.resolve(filteredCSSText));
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}